import { Box, styled, Typography } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.grey[700],
  padding: theme.spacing(1),
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[400],
  width: '100%',
  whiteSpace: 'nowrap',
  overflowX: 'hidden',
  textOverflow: 'ellipsis',
}));
